export const trimLocationText = text => {
  return text.split("-").length > 2
    ? text.split("-")[0] + ", " + text.split("-")[1] + "e altre sedi"
    : text
}
